module.exports = __webpack_public_path__ + "img/Openbanner2.b2d6236d.png";